(() => {
  const ROOT_SELECTOR = '.arl-variant-nutrition';

  function getPanels(root) {
    return Array.from(
      root.querySelectorAll('[data-arl-variant-id]')
    );
  }

  function showVariant(root, variantId) {
    const requestedId = String(variantId);
    const panels = getPanels(root);

    const matchingPanelExists = panels.some(
      (panel) =>
        panel.dataset.arlVariantId === requestedId
    );

    if (!matchingPanelExists) return false;

    panels.forEach((panel) => {
      panel.hidden =
        panel.dataset.arlVariantId !== requestedId;
    });

    root.dataset.arlActiveVariant = requestedId;

    return true;
  }

  function detectSelectedVariant(root) {
    const panels = getPanels(root);

    const validVariantIds = new Set(
      panels.map((panel) => panel.dataset.arlVariantId)
    );

    const variantInputs = Array.from(
      document.querySelectorAll(
        'form[action*="/cart/add"] [name="id"]'
      )
    );

    const matchingInputValues = variantInputs
      .map((input) => String(input.value || ''))
      .filter((value) => validVariantIds.has(value));

    if (matchingInputValues.length > 0) {
      const counts = new Map();
      let mostFrequentId = matchingInputValues[0];
      let highestCount = 0;

      matchingInputValues.forEach((id) => {
        const count = (counts.get(id) || 0) + 1;
        counts.set(id, count);

        if (count >= highestCount) {
          highestCount = count;
          mostFrequentId = id;
        }
      });

      return mostFrequentId;
    }

    const urlVariantId = new URL(
      window.location.href
    ).searchParams.get('variant');

    if (
      urlVariantId &&
      validVariantIds.has(String(urlVariantId))
    ) {
      return String(urlVariantId);
    }

    return null;
  }

  function synchronizeAll(directVariantId) {
    document
      .querySelectorAll(ROOT_SELECTOR)
      .forEach((root) => {
        if (
          directVariantId &&
          showVariant(root, directVariantId)
        ) {
          return;
        }

        const detectedVariantId =
          detectSelectedVariant(root);

        if (detectedVariantId) {
          showVariant(root, detectedVariantId);
        }
      });
  }

  function scheduleSynchronization(variantId) {
    synchronizeAll(variantId);

    setTimeout(
      () => synchronizeAll(variantId),
      50
    );

    setTimeout(
      () => synchronizeAll(variantId),
      250
    );
  }

  document.addEventListener(
    'variant:change',
    (event) => {
      const variant =
        event.detail && event.detail.variant;

      scheduleSynchronization(
        variant && variant.id ? variant.id : null
      );
    }
  );

  document.addEventListener(
    'change',
    () => scheduleSynchronization(),
    true
  );

  document.addEventListener(
    'shopify:section:load',
    () => scheduleSynchronization()
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => scheduleSynchronization()
    );
  } else {
    scheduleSynchronization();
  }

  setInterval(() => synchronizeAll(), 500);
})();